// The input length limit (psk, psk_id, info, exporter_context, ikm).
export const INPUT_LENGTH_LIMIT = 8192;
export const INFO_LENGTH_LIMIT = 65536;
// The minimum length of a PSK.
export const MINIMUM_PSK_LENGTH = 32;
// b""
export const EMPTY = new Uint8Array(0);
